import { Link } from 'react-router-dom'

import { CommRow } from './CommRow'
import { useJobCommunications } from './queries'

/** The conversations about one job, newest first. */
export function JobCommunications({ jobId }: { jobId: string }) {
  const query = useJobCommunications(jobId)
  const items = query.data ?? []

  if (query.isPending) return <p className="text-[length:var(--text-2xs)] text-taupe">Loading…</p>
  if (items.length === 0) {
    return (
      <p className="text-[length:var(--text-sm)] text-taupe">
        No messages linked yet. They appear after each email check (<Link to="/communications" className="underline underline-offset-4">Communications</Link>).
      </p>
    )
  }
  return (
    <ul className="flex flex-col gap-2">
      {items.map((comm) => (
        <CommRow key={comm.id} comm={comm} showJob={false} />
      ))}
    </ul>
  )
}
